// Footer.js
import React from 'react';
import { Box, Container, Typography } from '@mui/material';
function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    // <footer id="footer" className="footer">
    //   <div className="container">
    //     <div className="copyright">© {currentYear} Ebusso</div>
    //   </div>
    // </footer>
    <Box
      component="footer"
      sx={{
        borderTop: '1px solid rgba(8, 13, 17, 0.1)',
        backgroundColor: '#fff',
        py: 0.5,
        width: '100%',
      }}
    >
    <Container maxWidth="xl">
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'end',
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontSize: '0.875rem',
            color: '#000',
            fontWeight: 400,
          }}
        >
          © {currentYear} Ebusso. All rights reserved.
        </Typography>
      </Box>
    </Container>
  </Box>
  );
}
export default Footer;
